<!-- Il <form> avvolge contenuto e fascia delle azioni perche' il pulsante
     "Aggiungi" e' il submit: senza, il tasto Invio da un campo non
     salverebbe. Per la disposizione pero' titolo, contenuto e fascia devono
     essere figli DIRETTI della superficie, altrimenti la fascia panna non
     resta a filo del bordo inferiore - ci pensa `display: contents` sul form
     nello SCSS, che lo toglie di mezzo come scatola lasciando intatto
     l'ngSubmit. -->
<h2 mat-dialog-title>Registra un evento fiscale</h2>

<form #EventForm="ngForm" (ngSubmit)="addNewEvent()" class="izy-event-form">
  <mat-dialog-content>
    <!-- .izy-fields e' il contenitore che veste i campi con la grammatica BEIZY
         (contorno nero 2px, raggio 16px): lo stesso di tutti gli altri form
         dell'app. Definito in styles.scss. .izy-event-fields aggiunge solo la
         disposizione a due colonne. -->
    <div class="izy-fields izy-event-fields">
      <mat-form-field appearance="outline" class="izy-field-full">
        <mat-label>Nome evento</mat-label>
        <input matInput [(ngModel)]="newEvent.name" name="name" required />
      </mat-form-field>

      <mat-form-field appearance="outline" class="izy-field-half">
        <mat-label>Tipo</mat-label>
        <!-- La freccetta che ruota e il pannello bordato nero sono la stessa
             coppia .izy-select-trigger / .izy-select-panel--form usata dagli
             altri select di form dell'app. -->
        <mat-select
          [(ngModel)]="newEvent.type"
          name="type"
          class="izy-select-trigger"
          panelClass="izy-select-panel izy-select-panel--form"
          required>
          @for (type of typeOptions; track type.code) {
            <mat-option [value]="type.code">{{ type.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="izy-field-half">
        <mat-label>Importo</mat-label>
        <input
          matInput
          type="number"
          [(ngModel)]="newEvent.amount"
          name="amount"
          required />
      </mat-form-field>

      <mat-form-field appearance="outline" class="izy-field-full">
        <mat-label>Descrizione (opzionale)</mat-label>
        <input
          matInput
          type="string"
          [(ngModel)]="newEvent.description"
          name="description" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="izy-field-full">
        <mat-label>Data di emissione</mat-label>
        <input
          matInput
          [matDatepicker]="emissionDatePicker"
          [(ngModel)]="newEvent.date"
          name="date"
          required />
        <mat-datepicker-toggle
          matSuffix
          [for]="emissionDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #emissionDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- L'evento nasce gia' saldato: e' una conseguenza che l'utente scopre
         solo dopo aver salvato, quindi va detta prima, nel riquadro panna
         degli avvisi invece che come riga di testo in coda al modulo. -->
    <div class="izy-event-note izy-sharp-bl">
      <mat-icon>info</mat-icon>
      <span>Questo evento verrà considerato già pagato.</span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="izy-dialog-actions">
    <button
      mat-stroked-button
      type="button"
      mat-dialog-close
      class="izy-button-ghost custom-button-border">
      <mat-icon>close</mat-icon>
      Esci
    </button>

    <!-- L'azione della schermata: petrol pieno bordato nero, come il pulsante
         "Aggiungi evento" della pagina del piano fiscale da cui si arriva. -->
    <button
      matButton="filled"
      type="submit"
      [disabled]="!EventForm.valid"
      class="ms-2 izy-button-primary custom-button-border">
      <mat-icon>add</mat-icon>
      Aggiungi
    </button>
  </mat-dialog-actions>
</form>
